import { TopCustomerProps, TopProductProps, TopReportProps } from "../../pages/HomePage";

export const topCustomers: TopCustomerProps[] = [
  { tenantId: "5b973f99-77df-4beb-b27d-aa0c70b8482c", tenantName: "EY" },
  { tenantId: "e0793d39-0939-496d-b129-198edd916feb", tenantName: "Accenture" },
  { tenantId: "36da45f1-dd2c-4d1f-af13-5abe46b99921", tenantName: "Deloitte (O365D)" },
  { tenantId: "37c354b2-85b0-47f5-b222-07b48d774ee3", tenantName: "NHS" },
  { tenantId: "3cbcc3d3-094d-4006-9849-0d11d61f484d", tenantName: "Walmart Inc." }
];

export const topProducts: TopProductProps[] = [
  { productId: "43", productName: "Microsoft Purview Information Protection" },
  { productId: "10", productName: "Microsoft 365 Defender" },
  { productId: "28", productName: "Microsoft Entra ID" },
  { productId: "33", productName: "Microsoft Intune" },
  { productId: "36", productName: "Microsoft Priva Risk Management" }
];

export const topReports: TopReportProps[] = [
  { reportId: "d9179a1f-e0f5-4f5f-8a39-d21679163ca7", report: "Copilot for Security" },
  { reportId: "c8e2f927-58fe-43ca-be95-1d17dd00fb94", report: "Unified Insights Report" },
  { reportId: "7bf239e5-0ce4-41a1-a234-8ea2f3132dd4", report: "Microsoft Sentinel Report" },
  { reportId: "51188773-a4f0-49c4-b442-ebafcb3fc076", report: "UEM CAT Dash" },
  { reportId: "7943ae02-504f-48d0-b271-f8f967baab96", report: "Entra CAT Engagements" }
];

export const GET_KEY_AND_SEARCH_LIMIT = [
  { key: "Customers", value: "RecentlySearchedCustomers", limit: 10 },
  { key: "Products", value: "RecentlySearchedProducts", limit: 15 },
  { key: "Reports", value: "RecentlySearchedReports", limit: 10 },
];